import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Navbar from "../Navbar/Navbar";
import ReturnsView from "../ReturnsView/ReturnsView";
import SettingsView from "../SettingsView/SettingsView";
import AnalyticsView from "../AnalyticsView/AnalyticsView";
import styles from "./HomePage.module.css";

const HomePage = () => {
    const [returnOptionSelected, setReturnOptionSelected] = useState(null);
    const [settingsOptionSelected, setSettingsOptionSelected] = useState(null);
    const [analyticsOptionSelected, setAnalyticsOptionSelected] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const page = location.state?.page || "Returns";
    const [selectedPage, setSelectedPage] = useState(location.state?.page || page);
    const apiUrl = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("authToken");

    //if home page is hit and the account has a logistics provider code, re route to home_3pl
    useEffect(() => {
        const checkLogisticsProviderCode = async () => {
            try {
                const response = await fetch(`${apiUrl}/api/business_details/`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
            });
            const data = await response.json();
            if (data.logistics_provider_code) { navigate("/home_3pl"); }
            } catch (err) { console.error("Error fetching logistics provider code:", err); }
        }
        checkLogisticsProviderCode();
    }, []);

    useEffect(() => {
        if (location.state?.page) { setSelectedPage(location.state.page); }
    }, [location.state]);

    useEffect(() => { setSelectedPage(page); }, [page]); // Update selectedPage if the page prop changes

    useEffect(() => { setSettingsOptionSelected(null); }, [selectedPage]); //reset settings view if user navigates away
        
    return (
        <div className={styles.home_page_container}>
            <Helmet>
                <title>Home</title>
            </Helmet>
            <Navbar resetOption={() => setReturnOptionSelected(null)} selectedPage={selectedPage} setSelectedPage={setSelectedPage} />
            {selectedPage === "Returns" && (<ReturnsView returnOptionSelected={returnOptionSelected} setReturnOptionSelected={setReturnOptionSelected} apiUrl={apiUrl} token={token}/>)}
            {selectedPage === "Settings" && (<SettingsView settingsOptionSelected={settingsOptionSelected} setSettingsOptionSelected={setSettingsOptionSelected} />)}
            {selectedPage === "Analytics" && (<AnalyticsView analyticsOptionSelected={analyticsOptionSelected} setAnalyticsOptionSelected={setAnalyticsOptionSelected} />)}
        </div>
    );
};

export default HomePage;
